import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { E3IssuersEdit } from "./edit";
import { E3IssuersNew } from "./new";
import { E3IssuersTable } from "./table";

export default function E3Issuers() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Émetteurs");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<E3IssuersEdit />} />
      <Route index element={<E3IssuersTable />} />
      <Route path="/new" element={<E3IssuersNew />} />
    </Routes>
  );
}
